import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  refreshForm(event) {
    event.preventDefault()

    const form = this.element
    const formData = new FormData(form)
    formData.append('refresh', true)

    fetch(form.action, {
      method: form.method.toUpperCase(),
      headers: {
        Accept: 'text/vnd.turbo-stream.html'
      },
      body: formData
    }).then(response => response.text())
      .then((data) => {
        Turbo.renderStreamMessage(data)
      })
  }
}
